import Home from "./container/crachaAmbulante.home";
import Emitir from "./components/emitir/container/crachaAmbulante.emitir";
import Validar from "./components/validar/container/crachaAmbulante.validar";
import Result from "./components/validar/container/crachaAmbulante.validar.result";

const routes = [
  {
    name: "servicoEmpresa.crachaAmbulante",
    path: "/servicoEmpresa/crachaAmbulante",
    component: Home,
    breadCrumb: [{ text: "Serviços Empresas" }, { text: "Crachá Ambulante" }]
  },
  {
    name: "servicoEmpresa.crachaAmbulante.emitir",
    path: "/servicoEmpresa/crachaAmbulante/emitir",
    component: Emitir,
    breadCrumb: [
      { text: "Serviços Empresas" },
      { text: "Crachá Ambulante" },
      { text: "Emitir Crachá" }
    ]
  },
  {
    name: "servicoEmpresa.crachaAmbulante.validar",
    path: "/servicoEmpresa/crachaAmbulante/validar",
    component: Validar,
    breadCrumb: [
      { text: "Serviços Empresas" },
      { text: "Crachá Ambulante" },
      { text: "Validar Crachá" }
    ]
  },
  {
    name: "servicoEmpresa.crachaAmbulante.validar.result",
    path: "/servicoEmpresa/crachaAmbulante/validar/result",
    component: Result,
    breadCrumb: [
      { text: "Serviços Empresas" },
      { text: "Crachá Ambulante" },
      { text: "Validar Crachá" },
      { text: "Dados do Ambulante" }
    ]
  }
];

export default routes;
